/** Desktop runLaunchBrandAnimation phases, sampled by the same clock as its cue.
 * No CSS/setTimeout animation can continue while the cinema is paused. */
export function sampleBrandLaunch(ms:number){
 const smooth=(n:number)=>{const t=Math.max(0,Math.min(1,n));return t*t*(3-2*t);};
 if(ms<0||ms>=3400)return{energy:0,orange:0};
 if(ms<600)return{energy:.3*smooth(ms/600),orange:0};
 if(ms<1000)return{energy:.3+.16*smooth((ms-600)/400),orange:smooth((ms-600)/400)};
 if(ms<1600)return{energy:.46+.36*smooth((ms-1000)/600),orange:1};
 return{energy:.82*(1-smooth((ms-1600)/1800)),orange:1};
}
